// Core
export { default as createConnector } from './core/createConnector';
export { instantSearchContext, InstantSearchConsumer, InstantSearchProvider } from './core/context'; // Utils

export { HIGHLIGHT_TAGS } from './core/highlight';
export { default as version } from './core/version';
export { default as translatable } from './core/translatable'; // Widgets

export { default as Configure } from './widgets/Configure';
export { default as ExperimentalConfigureRelatedItems } from './widgets/ConfigureRelatedItems';
import { default as DynamicWidgets } from './widgets/DynamicWidgets';
/** @deprecated use DynamicWidgets */

var ExperimentalDynamicWidgets = DynamicWidgets;
export { ExperimentalDynamicWidgets, DynamicWidgets };
export { default as QueryRuleContext } from './widgets/QueryRuleContext';
export { default as Index } from './widgets/Index';
export { default as InstantSearch } from './widgets/InstantSearch'; // Connectors

export { default as connectAutoComplete } from './connectors/connectAutoComplete';
export { default as connectBreadcrumb } from './connectors/connectBreadcrumb';
export { default as connectConfigure } from './connectors/connectConfigure';
export { default as EXPERIMENTAL_connectConfigureRelatedItems } from './connectors/connectConfigureRelatedItems';
export { default as connectCurrentRefinements } from './connectors/connectCurrentRefinements';
import { default as connectDynamicWidgets } from './connectors/connectDynamicWidgets';
/** @deprecated use connectDynamicWidgets */

var EXPERIMENTAL_connectDynamicWidgets = connectDynamicWidgets;
export { connectDynamicWidgets, EXPERIMENTAL_connectDynamicWidgets };
export { default as connectGeoSearch } from './connectors/connectGeoSearch';
export { default as connectHierarchicalMenu } from './connectors/connectHierarchicalMenu';
export { default as connectHighlight } from './connectors/connectHighlight';
export { default as connectHits } from './connectors/connectHits';
export { default as connectHitsPerPage } from './connectors/connectHitsPerPage';
export { default as connectInfiniteHits } from './connectors/connectInfiniteHits';
export { default as connectMenu } from './connectors/connectMenu';
export { default as connectNumericMenu } from './connectors/connectNumericMenu';
export { default as connectPagination } from './connectors/connectPagination';
export { default as connectPoweredBy } from './connectors/connectPoweredBy';
export { default as connectQueryRules } from './connectors/connectQueryRules';
export { default as connectRange } from './connectors/connectRange';
export { default as connectRefinementList } from './connectors/connectRefinementList';
export { default as connectScrollTo } from './connectors/connectScrollTo';
export { default as connectSearchBox } from './connectors/connectSearchBox';
export { default as connectRelevantSort } from './connectors/connectRelevantSort';
export { default as connectSortBy } from './connectors/connectSortBy';
export { default as connectStateResults } from './connectors/connectStateResults';
export { default as connectStats } from './connectors/connectStats';
export { default as connectToggleRefinement } from './connectors/connectToggleRefinement';
export { default as connectHitInsights } from './connectors/connectHitInsights';
export { default as connectVoiceSearch } from './connectors/connectVoiceSearch'; // Types

export * from './types';